import styled from "styled-components";

export const PageContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 700px;
  width: calc(100% - 40px);
  padding: 20px;
  margin: 0 auto;
  padding-top: 100px;
`;

export const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;
